// extracted by mini-css-extract-plugin
export default {"header":"Header_header__qG3wv","logo":"Header_logo__5SB4a","nav":"Header_nav__JcZ1z","mobile_btn":"Header_mobile_btn__S7lz8"};